export const FILTER_POST = 'FILTER_POST';
export const STORE_POST = 'STORE_POST';
export const SORT_ASC = 'SORT_ASC';
export const SORT_DESC = 'SORT_DESC';
